import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { AnalysisRun } from '../schemas'

interface AnalysisState {
  tableId: string | null
  run: AnalysisRun | null
  error: string | null
  saving: boolean
  rowIds: string[]
  attachedUploadIds: string[]
  readRequestId: string | null
}
const initialState: AnalysisState = { tableId: null, run: null, error: null, saving: false, rowIds: [], attachedUploadIds: [], readRequestId: null }
const slice = createSlice({
  name: 'tableAnalysis',
  initialState,
  reducers: {
    watch(state, action: PayloadAction<string>) {
      if (state.tableId !== action.payload) {
        state.saving = false
        state.rowIds = []
        state.attachedUploadIds = []
      }
      state.readRequestId = null
      state.tableId = action.payload
      state.run = null
      state.error = null
    },
    refresh: (_state, _action: PayloadAction<string>) => {},
    visibleRows(state, action: PayloadAction<{ tableId: string; rowIds: string[] }>) {
      if (state.tableId === action.payload.tableId) state.rowIds = action.payload.rowIds
    },
    stop(state, action: PayloadAction<string>) {
      if (state.tableId === action.payload) return initialState
    },
    readStarted(state, action: PayloadAction<{ tableId: string; requestId: string }>) {
      if (state.tableId === action.payload.tableId && !state.saving) state.readRequestId = action.payload.requestId
    },
    // Reads carry an identity; mutation results omit it and invalidate any pending read.
    received(state, action: PayloadAction<{ tableId: string; run: AnalysisRun | null; requestId?: string }>) {
      if (action.payload.requestId !== undefined && action.payload.requestId !== state.readRequestId) return
      if (state.tableId === action.payload.tableId) {
        state.readRequestId = null
        state.run = action.payload.run
        state.error = null
      }
    },
    uploadAttached(state, action: PayloadAction<{ tableId: string; clientTmpId: string }>) {
      if (state.tableId === action.payload.tableId) state.attachedUploadIds.push(action.payload.clientTmpId)
    },
    failed(state, action: PayloadAction<{ tableId: string; error: string; requestId?: string }>) {
      if (action.payload.requestId !== undefined && action.payload.requestId !== state.readRequestId) return
      if (state.tableId === action.payload.tableId) {
        state.readRequestId = null
        state.error = action.payload.error
      }
    },
    control(state, _action: PayloadAction<{ tableId: string; action: 'cancel' | 'run-updated' }>) {
      state.readRequestId = null
      state.saving = true
    },
    controlFinished(state, action: PayloadAction<string>) {
      if (state.tableId === action.payload) state.saving = false
    },
  },
})
export const AnalysisActions = slice.actions
export default slice.reducer
